import { useTypedSelector } from '@/store/hooks'
import type { RootState } from '@/store'

type Selector<TSelected = unknown, TParams = unknown> = (
  state: RootState,
  ...params: TParams[]
) => TSelected

const useParamSelector = <TSelected = unknown, TParams = unknown>(
  selector: Selector<TSelected, TParams>,
  ...params: TParams[]
): TSelected => useTypedSelector((state) => selector(state, ...params))

export default useParamSelector
